import React, { useContext } from 'react';
import { Typography, Divider, Price, InfoBar } from 'fronton-react';
import { useRecoilValue } from 'recoil';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { DataContext } from 'entries/common/widgets/context';
import { useCalculationState } from 'pages/calculation/store/calculation';
import { getTotalCostComplimentaryProducts } from 'common/helpers/get-total-cost-complimentary-products.helper';
import { tintServiceIsAnyColorsSelected } from 'pages/calculation/store/tint-service';
import { getTintPrice } from 'pages/calculation/helpers/get-tint-price.helper';
import { Cart } from '../CalculationFooter/Cart';

export const AddToCart = () => {
  const remoteData = useContext(DataContext);
  const {
    calculationFormState,
    complimentaryProducts,
    totalAmount,
    totalComplimentaryProductCount,
  } = useCalculationState();
  const isAnyColorsSelected = useRecoilValue(tintServiceIsAnyColorsSelected);
  const dimensions = useRecoilValue(dimensionsAtom);
  const { checkedProducts } = dimensions;
  const totalPriceOfComplimentaryProducts = totalComplimentaryProductCount
    ? getTotalCostComplimentaryProducts({ complimentaryProducts, checkedProducts })
    : 0;
  const totalMainItem = totalAmount - totalPriceOfComplimentaryProducts;

  if (remoteData) {
    const { productId, weight } = remoteData;
    const count = Number(calculationFormState.count);
    const totalTintPrice = getTintPrice({ volume: weight, count: calculationFormState.count });
    const isTintPriceShowed = totalTintPrice !== null && isAnyColorsSelected;

    return (
      <AddToCartWrapper>
        <ResultSummWrapper>
          <Typography size="body_short" variant="s" color="text-primary">
            Основной товар
          </Typography>
          <Price
            align="right"
            fraction
            size="s"
            value={totalMainItem}
            variant="regular"
            className={PriceResultClassname}
          />
        </ResultSummWrapper>
        {isTintPriceShowed ? (
          <ResultSummWrapper>
            <Typography size="body_short" variant="s" color="text-primary">
              Колеровка
            </Typography>
            <Price
              align="right"
              fraction
              size="s"
              value={totalTintPrice}
              variant="regular"
              className={PriceResultClassname}
              prefixText="от "
              data-testid="tint-price"
            />
          </ResultSummWrapper>
        ) : null}
        {totalComplimentaryProductCount ? (
          <ResultSummWrapper>
            <Typography size="body_short" variant="s">
              Расходники и инструменты
            </Typography>
            <Price
              align="right"
              fraction
              size="s"
              value={totalPriceOfComplimentaryProducts}
              variant="regular"
              className={PriceResultClassname}
            />
          </ResultSummWrapper>
        ) : null}

        <Divider orientation="horizontal" variant="line" />
        <ResultSummWrapper isLast={!isAnyColorsSelected}>
          <Typography size="body_accent" variant="l">
            Итого
          </Typography>
          <Price
            align="right"
            fraction
            size="xl"
            value={totalAmount}
            variant="accent"
            data-testid="calculation-price"
            prefixText={isTintPriceShowed ? 'от ' : undefined}
          />
        </ResultSummWrapper>
        {isAnyColorsSelected ? (
          <ResultSummWrapper isLast>
            <InfoBar type="alert" className={InfoBarClassname}>
              Финальная стоимость в корзине
            </InfoBar>
          </ResultSummWrapper>
        ) : null}
        <Cart count={count} productId={productId} />
      </AddToCartWrapper>
    );
  }

  return null;
};

const AddToCartWrapper = styled.div`
  position: sticky;
  top: 72px;
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
  box-sizing: border-box;
  width: 372px;
  height: auto;
  padding: var(--space-400);
  background-color: var(--background-secondary);
  border-radius: 8px;

  @media (max-width: 1024px) {
    width: 100%;
  }
  @media (--only-mobile) {
    position: relative;
    height: auto;
    padding: var(--space-300);
  }
`;

const ResultSummWrapper = styled.div<{ isLast?: boolean }>`
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${props => (props.isLast ? 'var(--space-100)' : '0px')};
`;

const PriceResultClassname = css`
  width: auto;
`;

const InfoBarClassname = css`
  width: 100%;
`;
